export default __webpack_public_path__ + "static/media/photo.e0e381af.png";